import { useState } from "react";
import { Printer, Usb, Monitor } from "lucide-react";
import { toast } from "sonner";
import { getPrinterMode, setPrinterMode, printReceipt } from "@/lib/receipt";

const TEST_ORDER = {
  order_number: "TEST",
  order_type: "Gel-Al",
  payment_method: "Teslimde Nakit Ödeme",
  items: [{ name: "Deneme Ürünü", price: 100, quantity: 1, note: "Test fişi" }],
  subtotal: 90.91,
  tax: 9.09,
  total: 100,
};

const MODES = [
  { id: "browser", label: "Tarayıcı yazdırma", desc: "Bilgisayar / normal yazıcı", icon: Monitor },
  { id: "rawbt", label: "Kiosk USB yazıcı (RawBT)", desc: "Android kiosk, pencere açmadan", icon: Usb },
  { id: "rawbt2", label: "Kiosk USB yazıcı (RawBT - alternatif)", desc: "Onay penceresi çıkıyorsa bunu deneyin", icon: Usb },
];

export const PrinterSettingsCard = () => {
  const [mode, setMode] = useState(getPrinterMode());
  const choose = (m) => {
    setPrinterMode(m);
    setMode(m);
    toast.success("Bu cihazın yazıcı ayarı kaydedildi");
  };
  return (
    <div data-testid="printer-settings-card" className="bg-white border border-[var(--fb-border)] rounded-2xl p-5 mb-6">
      <div className="flex items-center gap-2 mb-1">
        <Printer className="w-5 h-5 text-[var(--fb-red)]" />
        <h3 className="font-display font-bold text-lg">Fiş Yazıcısı (bu cihaz)</h3>
      </div>
      <p className="text-sm text-[var(--fb-muted)] mb-4">Ayar sadece şu an kullandığınız cihaza kaydedilir. Kiosk tabletinde "Kiosk USB yazıcı" seçin.</p>
      <div className="grid sm:grid-cols-3 gap-3 mb-4">
        {MODES.map(({ id, label, desc, icon: Icon }) => (
          <button
            key={id}
            data-testid={`printer-mode-${id}`}
            onClick={() => choose(id)}
            className={`flex items-center gap-3 text-left p-4 rounded-xl border-2 transition-colors ${mode === id ? "border-[var(--fb-red)] bg-red-50" : "border-[var(--fb-border)] hover:border-[var(--fb-red)]"}`}
          >
            <Icon className="w-6 h-6 text-[var(--fb-red)] shrink-0" />
            <span>
              <span className="block font-bold">{label}</span>
              <span className="block text-xs text-[var(--fb-muted)]">{desc}</span>
            </span>
          </button>
        ))}
      </div>
      <button
        data-testid="printer-test-btn"
        onClick={() => printReceipt(TEST_ORDER, "kitchen")}
        className="inline-flex items-center gap-2 bg-[var(--fb-ink)] text-white font-semibold px-5 py-2.5 rounded-full hover:opacity-90"
      >
        <Printer className="w-4 h-4" /> Test fişi yazdır
      </button>
    </div>
  );
};
